var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{staticClass:"order-appeal-list-tabs",attrs:{"value":_vm.active},on:{"tab-click":_vm.onTabClick}},[_c('el-tab-pane',{attrs:{"label":"申诉列表","name":"appeal"}}),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"实习生统计","name":"internStat"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a487c6f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/components/OrderAppealListTabs.vue
// module id = 2378
// module chunks = 192 223